import React from 'react';
import { Alert, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

interface ErrorFallbackProps {
  message?: string;
  onRetry?: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ message = '数据加载失败', onRetry }) => (
  <div style={{ padding: 24 }}>
    <Alert
      message={message}
      type="error"
      showIcon
      action={
        onRetry ? (
          <Button size="small" icon={<ReloadOutlined />} onClick={onRetry}>
            重试
          </Button>
        ) : undefined
      }
    />
  </div>
);

export default ErrorFallback;
